import { mergeTypographyStyles } from '../utils.js';
import { opalBase } from './base.js';
// Archivo Narrow has custom letter spacing in Opal
export const archivoNarrow = mergeTypographyStyles(opalBase, {
    title5xl: {
        letterSpacing: -0.0625,
    },
    title4xl: {
        letterSpacing: -0.0625,
    },
    title3xl: {
        letterSpacing: -0.03125,
    },
});
//# sourceMappingURL=archivoNarrow.js.map